'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-as-nav-for');

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductImageCarousel = function ProductImageCarousel(el) {
  (0, _classCallCheck3.default)(this, ProductImageCarousel);

  if ((0, _functional.getElement)('[data-carousel="carousel-nav"]')) {
    this.el = el;
    var initialIndex = (0, _functional.getElements)('.prd-ProductImage_Item').findIndex(function (el) {
      return el.dataset.initialIndex === 'true';
    });
    var productImageCarousel = new _flickity2.default((0, _functional.getElement)('[data-carousel="carousel"]', { context: this.el }), {
      wrapAround: true,
      pageDots: false,
      cellAlign: 'center',
      adaptiveHeight: true,
      prevNextButtons: false,
      imagesLoaded: true,
      touchVerticalScroll: false,
      dragThreshold: 30,
      initialIndex: initialIndex
    });

    /**
     * Controls don't render correctly (in Chrome) when the slide is
     * inactive, so we reinitialise them when a video slide is active
     */
    productImageCarousel.on('change', function () {
      var video = (0, _functional.getElement)('.prd-ProductImage_Video', {
        content: productImageCarousel.selectedElement
      });

      if (!video) {
        return;
      }

      video.play();
    });

    // Find personalised select
    var personalisedSelect = document.querySelector('.js-Personalisation_Options');

    if (personalisedSelect) {
      // add a change event to determine what image should be selected
      personalisedSelect.addEventListener('change', function () {
        // get the gallery length and -1 from it to make index correct
        var scrollToImage = productImageCarousel.slides.length - 1;

        // If there is an image with alt text or filename that contains personalised then it is a personalised image.
        var personalisedImage = (0, _functional.getElement)('[data-personalised="true"]');

        if (personalisedImage) {
          // get the index of the personalised image
          scrollToImage = personalisedImage.dataset.index;
        }

        // if the select option is yes for personalised go to the last slide where personalised image sits
        if (personalisedSelect.value === 'Yes') {
          productImageCarousel.select(scrollToImage);

          // if they change back to no go back to first image which is the unpersonalised version
        } else {
          productImageCarousel.select(0);
        }
      });
    }

    // Setup custom buttons for main carousel
    var previousButtonMain = document.querySelector('.prd-MainControls_Previous');
    previousButtonMain.addEventListener('click', function () {
      productImageCarousel.previous();
    });

    var nextButtonMain = document.querySelector('.prd-MainControls_Next');

    nextButtonMain.addEventListener('click', function () {
      productImageCarousel.next();
    });

    productImageCarousel.on('dragStart.el', function (event, pointer) {
      document.ontouchmove = function (e) {
        e.preventDefault();
      };
    });

    productImageCarousel.on('dragEnd.flickity', function (event, pointer) {
      document.ontouchmove = function (e) {
        return true;
      };
    });

    var productImageThumbnailCarousel = new _flickity2.default((0, _functional.getElement)('[data-carousel="carousel-nav"]', { context: this.el }), {
      asNavFor: (0, _functional.getElement)('[data-carousel="carousel"]', {
        context: this.el
      }),
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      wrapAround: false,
      draggable: false,
      prevNextButtons: false,
      imagesLoaded: true,
      initialIndex: initialIndex
    });

    /**
     * @note asNavFor doesn't seem to work, so we'll add listeners ourselves
     */
    productImageCarousel.on('change', function (index) {
      productImageThumbnailCarousel.select(index);
    });

    productImageThumbnailCarousel.cells.forEach(function (cell, index) {
      cell.element.addEventListener('click', function () {
        productImageCarousel.select(index);
        productImageThumbnailCarousel.select(index);
      });
    });

    window.BAO = window.BAO || {};
    window.BAO.productImageCarousel = productImageCarousel;
    window.BAO.productImageThumbnailCarousel = productImageThumbnailCarousel;
  }
};

exports.default = ProductImageCarousel;